import { CliqueiAcheiClientResponseData } from '@app/services/types';
import { CliqueiAcheiData } from '@app/types';

export function adaptCliqueiAcheiClientResponseDataTo(data: CliqueiAcheiClientResponseData): CliqueiAcheiData {
  return {
    Cod_Cliente: data.Id,
    Aberto: data.Aberto ?? false,
    Atividade: data.AtividadePrincipal,
    Cod_Categoria: data.Cod_Categoria,
    Completo: data.Completo,
    CorMenu: data.CorMenu ?? null,
    CorMenuText: data.CorMenuText ?? null,
    Entrega: data.Entrega ?? false,
    Url_Cliente: data.Url_Cliente ?? '',
    FormasPagamento: data.Pagamento ? data.Pagamento.split(',').map((p) => p.trim()) : [],
    ModeloPaginaId: data.ModeloPaginaId,
    Nom_Categoria: data.Categoria,
    Nome: data.Nome,
    Url_BannerPagina: data.Url_BannerPagina ?? null,
    Url_Cidade: data.Url_Cidade,
    NomePuro: data.NomePuro,
    Horarios: data.Horario,
    Email: data.Email,
    UsaAgenda: data.UsaAgenda,
  };
}
